import { inject } from '@angular/core';

import { PaginationParametersStoreService } from '@connect-services/client/services/pagination-parameters-store.service';
import { AbstractComponent } from '@connect-services/src/app/abstract.component';
import { defaultPaginationParameters, PaginationParameters } from '@shared/client/models/pagination.model';

export abstract class AbstractPaginationComponent extends AbstractComponent {
    public paginationParameters: PaginationParameters = { ...defaultPaginationParameters };

    private readonly paginationParametersStoreService = inject(PaginationParametersStoreService);

    protected constructor() {
        super();

        this.paginationParameters.take = this.paginationParametersStoreService.getSavedTake(this.constructor.name);
    }

    public override destroyCallback(): void {
        this.paginationParametersStoreService.saveTake(this.constructor.name, this.paginationParameters.take);
    }
}
